import React from 'react'

export default function MailSend() {
  return (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M44.6428 6.25H5.35707C3.38463 6.25 1.78564 7.849 1.78564 9.82143V40.1786C1.78564 42.1511 3.38463 43.75 5.35707 43.75H44.6428C46.6153 43.75 48.2142 42.1511 48.2142 40.1786V9.82143C48.2142 7.849 46.6153 6.25 44.6428 6.25Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M1.78564 10.7142L22.7142 23.3008C23.356 23.6776 24.1648 23.8839 24.9999 23.8839C25.8351 23.8839 26.6439 23.6776 27.2856 23.3008L48.2142 10.7142" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
